import React, { ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import {
  DesktopSection,
  FlowioMessage,
  Level1Header,
  LoginPageContainer,
  LoginSection,
} from "../../../pages/Login/styles";

import FlowioErrorBoundary from "../../../atoms/FlowioErrorBoundary";

type Props = {
  children: ReactNode;
};
const LoginLayout = ({ children }: Props) => (
  <LoginPageContainer>
    <FlowioErrorBoundary>
      <LoginSection>{children}</LoginSection>
    </FlowioErrorBoundary>
    <FlowioErrorBoundary>
      <DesktopSection>
        <Level1Header>
          <FormattedMessage id="common.app" />
        </Level1Header>
        <FlowioMessage>
          <FormattedMessage id="login.flowio_message" />
        </FlowioMessage>
      </DesktopSection>
    </FlowioErrorBoundary>
  </LoginPageContainer>
);

export default LoginLayout;
